onDomReady(function() {
   Icons.addEvents();
});

export var Icons = (window.Icons = {
   addEvents: function(el, force) {
      if (!el) {
         el = $(document.body);
      }

      var toggleImages = function(el) {
         var imgs = el.getElements('img');
         if (imgs.length == 2) {
            imgs.invoke('toggleClass', 'hidden');
         }
      };

      el.getElements('.iconLink').each(function(icon) {
         if (force || !icon.retrieve('iconEventAdded', false)) {
            var fn = toggleImages.pass(icon);
            icon.store('iconEventAdded', true);
            icon.addEvents({
               mouseenter: fn,
               mouseleave: fn,
            });
         }
      });

      return el;
   },
});
